module.exports = __webpack_public_path__ + "static/product_sans_regular-webfont-fd9762b639fe687bd60c88ca6e77e455.woff";